<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<span
  #popoverRef="ngbPopover"
  [ngbPopover]="popoverContent"
  [placement]="placement()"
  [popoverClass]="effectivePopoverClass()"
  [container]="container()"
  [disablePopover]="disabled()"
  [triggers]="effectiveTriggers()"
  [openDelay]="openDelay()"
  [closeDelay]="closeDelay()"
  [class.sticky-trigger]="sticky()"
  [style.cursor]="cursor()"
  (mouseenter)="sticky() ? showPopover() : null"
  (mouseleave)="sticky() ? hidePopover() : null"
>
  <!-- Trigger content - whatever you want to hover over -->
  <ng-content></ng-content>
</span>

<!-- Popover content template -->
<ng-template #popoverContent>
  <!-- Wrapper for sticky behavior with extended hover area -->
  <div
    [class.sticky-content]="sticky()"
    (mouseenter)="sticky() ? cancelHide() : null"
    (mouseleave)="sticky() ? hidePopover(true) : null">
    <!-- Projected popover content -->
    <ng-content select="[slot=popover-content]"></ng-content>
  </div>
</ng-template>
